import { type QueryCache, type QueryCacheSubscriptionChangeHandler } from '@kaiizen/react-persistent-cache';

const REFETCH_EVENT = 'refetch';

export type RealtimeSubscription = {
  unsubscribe: () => void;
};

export type RealtimeClient = {
  subscribe: (
    channelName: string,
    eventName: string,
    callback: (payload: unknown) => void,
  ) => RealtimeSubscription;
};

type ActiveSubscription = {
  unsubscribe: () => void;
};

export const createSubscriptionChangeHandler = (
  realtimeClient: RealtimeClient,
  onUpdate: (queryCache: QueryCache<unknown>, key: string, payload: unknown) => void,
): QueryCacheSubscriptionChangeHandler => {
  const subscriptionsByKey = new Map<string, ActiveSubscription>();

  return (queryCache: QueryCache<unknown>, key: string, subscriberCount: number) => {
    const existingSubscription = subscriptionsByKey.get(key);

    if (subscriberCount <= 0 && existingSubscription) {
      existingSubscription.unsubscribe();
      subscriptionsByKey.delete(key);
      return;
    }

    if (subscriberCount > 0 && !existingSubscription) {
      const subscription = realtimeClient.subscribe(
        key,
        REFETCH_EVENT,
        (payload: unknown) => onUpdate(queryCache, key, payload),
      );
      subscriptionsByKey.set(key, { unsubscribe: subscription.unsubscribe });
    }
  };
};
